import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import NP from '../1. Core/NP';
import {ServerAPI} from '../1. Core/ServerAPI';
import IconToggleButton from '../1. Core/Controls/IconToggleButton/IconToggleButton';
import CreateFighterCardV2SpecialDialog from './CreateFighterCardV2SpecialDialog';
import Menu from '../1. Core/Controls/Menu/Menu';
import ListItem from '../1. Core/Controls/ListBox/ListItem';

interface FighterCardV2SpecialRow {
	catalogId: number;
	fullName: string;
	weightClassKey: string;
	displayOrder: number;
	athleteId?: number;
	active: boolean;
	photoUrl?: string;
	athleteRating?: { total?: number };
}

export default class FighterCardV2SpecialList extends Control {
	private _topAppBar: TopAppBar;
	private EvShowPageModeClick: Delegate;
	private _dataTable: DataTable;

	constructor(settings: object) {
		super(settings);
		this._render();
	}

	_initFields(settings: object) {
		this.EvShowPageModeClick = new Delegate();
		super._initFields(settings);
	}

	getTopAppBar() {
		return this._topAppBar;
	}

	_render() {
		this.np_render();
		this.addClass('');

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: 'Fighter cards v2 — Special',
			ParentNode: this._root,
			ShowSearchButton: false,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this),
			},
			RightItems: NP.getCurrentUser().isBDAdmin()
				? [
					new IconToggleButton({
						FontImage: NP.FontImages.add,
						ToolTip: 'Add special fighter',
						EvClick: () =>
							new CreateFighterCardV2SpecialDialog({
								EvOkButtonClick: () => this.refresh(),
							}).show(),
					}),
				]
				: [],
		});

		this._dataTable = new DataTable({
			ParentNode: this._root,
			ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: false,
			EnableSort: false,
			ImageWidth: 40,
			ImageProperty: 'photoUrl',
			Columns: [
				{Content: 'Id', PropertyContent: 'catalogId', Width: '8%'},
				{Content: 'Name', PropertyContent: 'fullName', Width: '22%'},
				{Content: 'Weight key', PropertyContent: 'weightClassKey', Width: '18%'},
				{Content: 'Order', PropertyContent: 'displayOrder', Width: '8%'},
				{Content: 'Athlete', PropertyContent: 'athleteId', Width: '8%'},
				{Content: 'Rating', PropertyContent: 'ratingTotal', Width: '8%'},
				{Content: 'Active', PropertyContent: 'activeLabel', Width: '8%'},
			],
			ShowPaginator: false,
			EvItemContextMenu: async (s: any, e: { Event: any; Item: FighterCardV2SpecialRow }) => {
				if (!NP.getCurrentUser().isBDAdmin()) {
					return;
				}
				const row = e.Item;
				const menu = new Menu({
					Items: [
						{
							FontImage: NP.FontImages.edit,
							Content: row.active ? 'Deactivate' : 'Activate',
							Value: 'toggle',
						},
					],
					EvItemSelected: async (sender: Menu, event: { Item: ListItem }) => {
						if (event.Item.getValue() === 'toggle') {
							await ServerAPI.post<boolean>(
								`/fighter-cards/v2/catalog/special/${row.catalogId}/active?active=${!row.active}`,
							);
							this.refresh();
						}
					},
				});
				menu.showContextMenu(e.Event);
			},
		});

		this.refresh();
	}

	async refresh() {
		const rows = await ServerAPI.get<FighterCardV2SpecialRow[]>(
			'/fighter-cards/v2/catalog/special',
		);
		this._dataTable.setRows(
			(rows || []).map(r => ({
				...r,
				ratingTotal: r.athleteRating?.total ?? '',
				activeLabel: r.active ? 'yes' : 'no',
			})),
		);
	}
}
